/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { ActionIcon, Flex } from '@mantine/core';

// Styles
import {
	IconLayoutGrid,
	IconList,
} from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
export type TViewMode = 'grid' | 'list';

type TViewToggleProps = {
	mode: TViewMode;
	onChange: (mode: TViewMode) => void;
};

const icons = {
	grid: IconLayoutGrid,
	list: IconList,
} as const;

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const ViewToggle: React.FC<TViewToggleProps> = ({
	mode,
	onChange,
}) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Flex gap={'var(--mantine-spacing-xs)'}>
			{(['grid', 'list'] as TViewMode[]).map((view) => {
				const Icon = icons[view];

				const isActive = mode === view;

				return (
					<ActionIcon
						key={view}
						variant={isActive ? 'filled' : 'outline'}
						size="48px"
						radius="xl"
						color={
							isActive
								? 'var(--mantine-color-igluPrimary-9)'
								: 'var(--mantine-color-igluBorder-9)'
						}
						onClick={() => onChange(view)}
						aria-label={`Switch to ${view} view`}
					>
						<Icon
							size={24}
							stroke={1.5}
							color={
								isActive
									? 'white'
									: 'var(--mantine-color-igluPrimary-9)'
							}
						/>
					</ActionIcon>
				);
			})}
		</Flex>
	);
};
